var __TEMP__ = require('./_baseToString.js');var baseToString = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_castSlice.js');var castSlice = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_charsStartIndex.js');var charsStartIndex = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_stringToArray.js');var stringToArray = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./toString.js');var toString = __REQUIRE_DEFAULT__(__TEMP__);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * Removes leading whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimStart('  abc  ');
 * // => 'abc  '
 *
 * _.trimStart('-_-abc-_-', '_-');
 * // => 'abc-_-'
 */
function trimStart(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrimStart, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      start = charsStartIndex(strSymbols, stringToArray(chars));

  return castSlice(strSymbols, start).join('');
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = trimStart;
